import dataSource from "../data/DataSource";
import alertService from "../components/core/alert/AlertService";

export default {

  getClientImageUrl(clientId, documentId) {
    return new Promise(resolve => {
      dataSource.getClientImage(clientId, documentId)
        .then(res => {
          if (res.errorOccurred) {
            alertService.alert({ message: res.data })
          } else {
            var blob = new Blob([res.data], { type: 'image/jpeg' });
              resolve(URL.createObjectURL(blob))

          }
        })
    })
  }
}